/** When an invitation lapses, as the console states it: "Expires Feb 8". */
export function formatInvitationExpiry(expiresAt: string): string {
  const date = new Date(expiresAt).toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return `Expires ${date}`;
}
